// extracted by mini-css-extract-plugin
module.exports = {"form":"styles__form___3VeZe","formFullWidth":"styles__formFullWidth___34Qgm styles__form___3VeZe"};